const required = { required: 'validation.required' };
const minLenght = (value: number) => ({
  minLength: {
    value,
    message: 'validation.minLength',
  },
});
const maxLenght = (value: number) => ({
  maxLength: {
    value,
    message: 'validation.maxLength',
  },
});

const pattern = {
  nAn: {
    pattern: {
      value: /^\d+$/,
      message: 'validation.pattern.nan',
    },
  },
  taxCode: {
    pattern: {
      value: /^[A-Za-z]{6}[0-9]{2}[A-Za-z]{1}[0-9]{2}[A-Za-z]{1}[0-9]{3}[A-Za-z]{1}$/i,
      message: 'validation.pattern.fiscalCode',
    },
  },
  email: {
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'validation.pattern.email',
    },
  },
  password: {
    pattern: {
      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~!-@#$&*]{6,20}$/,
      message: 'validation.pattern.password',
    },
  },
  blank: {
    pattern: {
      value: /^\S+$/i,
      message: 'validation.pattern.blank',
    },
  },
  letters: {
    pattern: {
      value: /^[a-zA-Z]+$/i,
      message: 'validation.pattern.letters',
    },
  },
  username: {
    pattern: {
      value: /^[a-zA-Z0-9-_.]+$/,
      message: 'validation.pattern.blankOrCharNotAllowed',
    },
  },
  website: {
    pattern: {
      value: /^[-a-zA-Z0-9@:%._+~#=/]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)+$/,
      message: 'validation.pattern.website',
    },
  },
  name: {
    pattern: {
      value: /^[^!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?]+$/,
      message: 'validation.pattern.charNotAllowed',
    },
  },
};

export const validationSchema = {
  required,
  userName: {
    ...required,
    ...minLenght(3),
    ...maxLenght(50),
    ...pattern.username,
  },
  social: {
    ...minLenght(3),
    ...maxLenght(50),
    ...pattern.username,
  },
  website: {
    ...pattern.website,
  },
  password: {
    ...required,
    ...pattern.password,
  },
  confirmPassword: {
    ...required,
    type: {
      match: {
        message: 'global.messages.error.dontmatch',
      },
    },
  },
  firstName: {
    ...required,
    ...maxLenght(50),
    ...pattern.name,
  },
  lastName: {
    ...required,
    ...maxLenght(50),
    ...pattern.name,
  },
  companyName: {
    ...required,
    ...minLenght(3),
    ...maxLenght(50),
  },
  taxCode: {
    ...required,
    ...pattern.taxCode,
  },
  mobileLine: {
    ...required,
    ...minLenght(8),
    ...maxLenght(20),
    ...pattern.nAn,
  },
  landLine: {
    ...minLenght(8),
    ...maxLenght(20),
    ...pattern.nAn,
  },
  rui: {
    ...required,
    ...minLenght(9),
    ...maxLenght(9),
  },
  vat: {
    ...required,
    ...minLenght(9),
    ...maxLenght(9),
  },
  email: {
    ...required,
    ...pattern.email,
  },
  street: {
    ...required,
    ...minLenght(3),
    ...maxLenght(50),
  },
  streetNumber: {
    ...required,
    ...maxLenght(5),
    ...pattern.nAn,
  },
  zipCode: {
    ...required,
    ...maxLenght(5),
    ...pattern.nAn,
  },
  town: {
    ...required,
    ...minLenght(3),
    ...maxLenght(50),
  },
  province: {
    ...required,
    ...maxLenght(2),
    ...pattern.letters,
  },
};
